import type { NodeTypes } from '@xyflow/react';
import { FlowNode } from './FlowNode';

/**
 * All IR node kinds render through the one FlowNode component (it switches on kind for distinct
 * visuals). Registering per-type keys keeps the seam for PS-2 to split any kind into a bespoke
 * component (e.g. an interactive decision editor) without touching the layout/adapter layer.
 */
export const nodeTypes: NodeTypes = {
  capability: FlowNode,
  decision: FlowNode,
  humanTask: FlowNode,
  subFlow: FlowNode,
  multiSourceScoring: FlowNode,
  terminal: FlowNode,
  ai: FlowNode,
  flowControl: FlowNode,
};
